import { render, staticRenderFns } from "./OrderAdmittanceIssuance.vue?vue&type=template&id=90b343fe&scoped=true&"
import script from "./OrderAdmittanceIssuance.vue?vue&type=script&lang=js&"
export * from "./OrderAdmittanceIssuance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b343fe",
  null
  
)

export default component.exports
import {QItem,QInput,QBtn,QTooltip,QDialog} from 'quasar'
component.options.components = Object.assign({QItem,QInput,QBtn,QTooltip,QDialog}, component.options.components || {})
